import { gql } from '@apollo/client';

export const searchApplicationUsersByName = gql`
  query ($name: String!) {
    searchApplicationUsers(name: $name) {
      id
      name
    }
  }
`;

export const readOwnerByNumber = gql`
  query ($ownerNumber: String!) {
    readOwnerByNumber(ownerNumber: $ownerNumber) {
      PhysicalOwner
      PhysOwnerDeptId
      DepartmentId
      userId
      userName
    }
  }
`;

export const updateOwnerMutation = gql`
  mutation ($owner: OwnerInput!) {
    updateOwner(owner: $owner)
  }
`;
